<template>
	<div>
		<div class="flex justify-between sticky items-center">
			<slot name="header_left">
				<BaseInput :label="$t('search')" v-model="sword" v-if="enableSearch" />
			</slot>
			<slot name="header_right"></slot>
		</div>
		<table class="w-full table-fixed">
			<thead class="bg-transparent">
				<HeaderRow class="border-b">
					<HeaderColumn v-for="(head, index) in heads" :key="index" @click="setSorting(head.key)" :class="head.class" :colspan="head.colspan || 5">
						{{ head.title }}
						<span class="opacity-0" :class="{ 'opacity-100': sorting.column === head.key }">
							<font-awesome-icon :icon="['fa', 'sort-amount-down']" class="w-5 h-5 pr-1" size="lg" v-if="sorting.direction === 'asc'" />
							<font-awesome-icon :icon="['fa', 'sort-amount-up-alt']" class="w-5 h-5 pr-1" size="lg" v-else />
						</span>
					</HeaderColumn>
					<th v-if="showSuffix" />
				</HeaderRow>
			</thead>
			<tbody class="bg-white" v-if="rows">
				<BaseRow
					v-for="row in filteredSortedRows"
					:key="row.id"
					:clickable="rowMainFunction !== null"
					@click="rowMainFunction && rowMainFunction(row)"
				>
					<BaseColumn
						v-for="(head, index) in heads"
						:key="index"
						:title="row[head.key]"
						v-on="head.action ? { click: () => head.action(row) } : {}"
						:colspan="head.colspan || 5"
					>
						{{ row[head.key] }}
					</BaseColumn>
					<SuffixColumn v-if="showSuffix">
						<slot name="suffix" :row="row">
							<button @click="rowMainFunction(row)" class="bg-connectProBlue text-white px-2 py-1 rounded">
								<font-awesome-icon :icon="['fas', 'edit']"></font-awesome-icon>
							</button>
						</slot>
					</SuffixColumn>
				</BaseRow>
				<BaseRow v-for="row in this.fillerRows" :key="row.id">
					<BaseColumn v-for="(head, index) in heads" :key="index" :title="row[head.key]" class="opacity-0" :colspan="head.colspan || 5">A</BaseColumn>
					<SuffixColumn v-if="showSuffix" column-class="opacity-0">
						<slot name="suffix" :row="row">
							<button class="bg-connectProBlue text-white px-2 py-1 rounded">
								<font-awesome-icon :icon="['fas', 'edit']"></font-awesome-icon>
							</button>
						</slot>
					</SuffixColumn>
				</BaseRow>
			</tbody>
			<tbody v-else>
				<LoadingSpinner />
			</tbody>
		</table>
	</div>
</template>

<script>
import { parseDate } from '@/mixins/date';
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseRow from '@/components/rows/BaseRow';
import BaseColumn from '@/components/columns/BaseColumn';
import SuffixColumn from '@/components/columns/SuffixColumn';
import HeaderColumn from '@/components/columns/HeaderColumn';
import HeaderRow from '@/components/rows/HeaderRow';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';

export default {
	name: 'BaseTable',
	components: { LoadingSpinner, HeaderRow, HeaderColumn, SuffixColumn, BaseColumn, BaseRow, BaseInput },
	props: {
		rows: {
			type: Array,
			default: () => [],
			required: true,
		},
		heads: {
			type: Array,
			default: () => [],
			required: true,
		},
		mapping: {
			type: Function,
			default: () => [],
			required: true,
		},
		rowMainFunction: {
			type: Function,
			default: null,
		},
		enableSearch: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			sword: '',
			sorting: {
				column: '',
				direction: 'asc',
			},
		};
	},
	computed: {
		showSuffix() {
			return !!this.$scopedSlots['suffix'] || this.rowMainFunction;
		},
		mappedRows() {
			return this.rows.map(this.mapping);
		},
		filteredSortedRows() {
			const rows = this.mappedRows;
			return rows.sort(this.logicSort).filter(this.logicFilter);
		},
		fillerRows() {
			const array = [];
			// fill to have a min size of table
			for (let i = this.filteredSortedRows.length; i < this.mappedRows.length; i++) {
				array.push({ id: 'hidden_' + i, hidden: true });
			}
			return array;
		},
	},
	methods: {
		setSorting(column, direction = 'asc') {
			if (column === this.sorting.column) {
				this.sorting.direction = this.sorting.direction === 'asc' ? 'desc' : 'asc';
			} else {
				this.sorting.column = column;
				this.sorting.direction = direction;
			}
		},
		logicSort(a, b) {
			if (this.sorting.column === '') {
				return 0;
			}

			const valueA = a[this.sorting.column].toString().toLowerCase();
			const valueB = b[this.sorting.column].toString().toLowerCase();

			if (Date.parse(valueA) && Date.parse(valueB)) {
				const dateA = parseDate(valueA, 'dd.mm.yyyy');
				const dateB = parseDate(valueB, 'dd.mm.yyyy');
				return this.dateStrategy(dateA, dateB);
			} else {
				return this.stringStrategy(valueA, valueB);
			}
		},
		stringStrategy(valueA, valueB) {
			let comp = 0;
			if (valueA === valueB) {
				return comp;
			}

			if (this.sorting.direction === 'asc') {
				comp = valueA > valueB ? 1 : -1;
			} else {
				comp = valueA < valueB ? 1 : -1;
			}

			return comp;
		},
		dateStrategy(dateA, dateB) {
			let comp = 0;

			if (dateA === dateB) {
				return comp;
			}

			if (this.sorting.direction === 'asc') {
				comp = dateA > dateB ? 1 : -1;
			} else {
				comp = dateA < dateB ? 1 : -1;
			}

			return comp;
		},
		logicFilter(row) {
			let found = false;
			for (const property in row) {
				if (!found) {
					const value = (row[property] ?? '').toString().toLowerCase();
					const sword = this.sword.toLowerCase();
					found = value.includes(sword);
				}
			}
			return found;
		},
	},
};
</script>
